import * as React from "react";

import "./step-1-select-target.scss";

import {cs}             from "@Common/react/chain-services";
import {consumeContext} from "@Common/react/context";
import {keyed}          from "@Common/react/keyed";
import {Load2}          from "@Common/react/load2";
import {UseState}       from "@Common/react/use-state";

import {Header}    from "../../common/header/header";
import {InfoBlock} from "../../common/info-block/info-block";

export const Step1SelectTarget = ({onSelect, onCancel, entityId, cancelLabel}) => cs(   
    consumeContext("apis"),
    ["targets", ({apis}, next) => Load2({       
        fetch: () => apis.next.mailing.demographics.getTargets({entityId}),
        next,
    })],
    ["selecting", (_, next) => UseState({next})],
    ({targets, selecting}) => (
        <div className="step-1-select-target-1nx">
            {Header({
                icon: require("../../../../mailing-icons/listtype-demographics.png"),
                title: "Demographics Search",
                subTitle: "Create a list around demographic filters.",
            })}

            <div className="content">
                {InfoBlock({
                    content: (
                        <div className="instruction-43r">
                            Targeting parameters for new demographic lists will be stored for 24 hours. If the first use of the mailing list doesn't occur within 24 hours, it will no longer be available for use.
                        </div>
                    ),
                    xdQaName: "Demographics Search Demographics Info",
                })}

                {targets.loading ? (
                    <div className="loading" xd-qa-type="label" xd-qa-name="Demographics Search Loading targets configuration...">
                        Loading targets configuration...
                    </div>
                ) : !Array.isArray(targets.value) ? (
                    <div className="loading" xd-qa-type="label" xd-qa-name="Demographics Search Error">
                        This feature has not been configured properly.
                    </div>
                ) : (
                    targets.value.map((targetConfig) => ({
                        ...targetConfig,
                        name: targetConfig.name ?? guessTargetName(targetConfig.description),
                    }))
                        .map(({name, description, targets}, i) => (
                            <div className="section" key={i}>
                                <div className="header">
                                    {name && (
                                        <div className="title" xd-qa-type="label" xd-qa-name={"Demographics Search "+name}>
                                            {name}
                                        </div>
                                    )}
                                    <div className="sub-title" xd-qa-type="label" xd-qa-name={"Demographics Search "+name+" Description"}>
                                        {description}
                                    </div>
                                </div>

                                <div className="box">
                                    {targets.map(({idSearch, description, longDescription}) => cs(
                                        keyed(idSearch),
                                        ({}) => (
                                            <div className="type">
                                                <div
                                                    className="label"
                                                    onClick={() => {
                                                        if (selecting.value) {
                                                            return;
                                                        }
                                                        selecting.onChange(idSearch);
                                                        onSelect(idSearch);
                                                    }}
                                                >
                                                    <div className="text" xd-qa-type="link" xd-qa-name={"Demographics Search "+description}>
                                                        {description}
                                                    </div>
                                                    {selecting.value === idSearch && (
                                                        <div className="selecting" xd-qa-type="label" xd-qa-name="Demographics Search Selecting target...">
                                                            Selecting target...
                                                        </div>
                                                    )}
                                                </div>
                                                <div 
                                                    className="description"
                                                    dangerouslySetInnerHTML={{__html: longDescription}}
                                                    xd-qa-type="label"
                                                    xd-qa-name={"Demographics Search "+description+" Description"}/>
                                            </div>
                                        ),
                                    ))}
                                </div>
                            </div>
                        ))
                )}
            </div>

            <div className="footer">
                <div className="text" xd-qa-type="label" xd-qa-name={"Demographics Search " + cancelLabel}>
                    <a onClick={onCancel} xd-qa-type="link" xd-qa-name={"Demographics Search " + cancelLabel}>{cancelLabel}</a>
                </div>
            </div>
        </div>
    ),
);

const guessTargetName = (description) => (
    description.includes("Consumer") ? (
        "Find Consumers"
    ) : description.includes("Business") ? (
        "Find Businesses"
    ) : (
        null
    )
);